import { render, staticRenderFns } from "./drReport.vue?vue&type=template&id=ff5a9212&scoped=true"
import script from "./drReport.vue?vue&type=script&lang=js"
export * from "./drReport.vue?vue&type=script&lang=js"
import style0 from "./drReport.vue?vue&type=style&index=0&id=ff5a9212&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5a9212",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff5a9212')) {
      api.createRecord('ff5a9212', component.options)
    } else {
      api.reload('ff5a9212', component.options)
    }
    module.hot.accept("./drReport.vue?vue&type=template&id=ff5a9212&scoped=true", function () {
      api.rerender('ff5a9212', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printReport/drReport/drReport.vue"
export default component.exports